import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
export class AnimatedButtonComponent {
    constructor() {
        this.onerror = () => {
            // This is intentional
        };
        this.onsuccess = (_) => {
            // This is intentional
        };
        this.small = false;
        this.disabled = false;
        this.rollbackClickWhenError = false;
        this.animated = true;
        this.wasExecuted = false;
        this.clicked = false;
        this.lock = false;
    }
    ngOnInit() {
        this.clicked = this.wasExecuted;
        this.lock = this.clicked;
    }
    onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.lock) {
                this.lock = true;
                if (this.animated) {
                    this.clicked = true;
                }
                try {
                    const response = yield this.onclick();
                    this.onsuccess(response);
                }
                catch (error) {
                    this.onerror(error);
                    if (this.rollbackClickWhenError) {
                        this.clicked = false;
                    }
                }
            }
        });
    }
}
